export const authFetch = async (url, options = {}) => {

  const token = localStorage.getItem("token")
  const isFormData = options.body instanceof FormData

  const res = await fetch(url, {
    ...options,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })

  if (res.status === 401) {
    localStorage.removeItem("token")
    window.location.href = "/login"
  }

  return res
}